import { t as e } from "../utils-DiFe-_ei.js";
import { a as t, i as n, n as r, r as i, t as a } from "../dist-Bbyy0Cx5.js";
import * as o from "react";
import { jsx as s } from "react/jsx-runtime";
//#region src/foundations/popover/popover.tsx
var c = n, l = t, u = a, d = o.forwardRef(({ className: t, align: n = "center", sideOffset: a = 4, ...o }, c) => /* @__PURE__ */ s(i, { children: /* @__PURE__ */ s(r, {
	ref: c,
	align: n,
	sideOffset: a,
	className: e("z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-popover-content-transform-origin]", t),
	...o
}) }));
d.displayName = r.displayName;
//#endregion
export { c as Popover, u as PopoverAnchor, d as PopoverContent, l as PopoverTrigger };

//# sourceMappingURL=popover.js.map